import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import localStorageConstants from "src/app/constants/localStorage.constants";
import limitedRouteModel from "src/app/models/components/limitedRoute.model";

const LimitedRoute: React.FC<limitedRouteModel> = (
  limitedRouteProps: limitedRouteModel,
) => {
  const { roles } = limitedRouteProps;
  const userRole: string | null = localStorage.getItem(
    localStorageConstants.ROLE,
  );
  if (!userRole) return <Navigate to="/" replace />;

  if (!roles.includes(userRole)) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default LimitedRoute;
